import { useFormik } from "formik";
import login from "../validations/Login/login";
import resetEmail from "../validations/Login/resetEmail";

// import { ILogin } from "../types/ILogin";
import LoginApi from "../api/login";
import { useUser } from "../context/UserContext";
import { useCallback, useEffect, useRef, useState } from "react";
import { useAlert } from "../context/AlertContext";
import otp from "../validations/Login/otp";
import password from "../validations/Login/password";
import { useContent } from "../content/useContent";

const useLoginContainer = () => {
  // const { setUser, setToken } = useUser();
  const { setToken } = useUser();
  const { generalErrors, pages, schema } = useContent();

  const { setSuccessMessage, setErrorMessage } = useAlert();

  const [loading, setLoading] = useState<boolean>(false);
  const [showResetEmail, setShowResetEmail] = useState<boolean>(false);
  const [showOtp, setShowOtp] = useState<boolean>(false);
  const [otpUser, setOtpUser] = useState<any>(null);
  const [count, setCount] = useState(0);

  let intervalRef: any = useRef();

  const decreaseNum = () => {
    if (count > 0) {
      setCount((prev: any) => prev - 1);
    }
  };

  useEffect(() => {
    intervalRef.current = setInterval(decreaseNum, 1000);

    return () => clearInterval(intervalRef.current);
  }, [count]);

  const handleShowLogin = () => {
    setShowResetEmail(false);
    setShowOtp(false);
    setOtpUser(null);
  };

  const initialValuesLogin = {
    username: "",
    password: "",
  };

  const initialValuesResetEmail = {
    email: "",
  };

  const initialValuesOtp = {
    otp: "",
  };

  const initialValuesConfirmPassword = {
    password: "",
    confirmPassword: "",
  };

  const onSuccess = (data: any) => {
    // const { user, access_token } = data;
    // setUser(user);
    const { access_token } = data;
    setToken(access_token);
    // localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("kafd-app-token", JSON.stringify(access_token));
  };

  const handleLogin = async (values: any) => {
    const body = {
      grant_type: "password",
      username: values.username,
      password: values.password,
      client_id: process.env.REACT_APP_CLIENT_ID!
    };
    setLoading(true);

    try {
      const data = await LoginApi.Login(body);
      onSuccess(data);
    } catch (error: any) {
      console.log({ error });
      if (error?.response?.data?.error_description) {
        setErrorMessage(error.response.data.error_description);
      } else {
        setErrorMessage(generalErrors.wentWrong);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleResetEmail = async (values: { email: string }) => {
    setLoading(true);
    try {
      await LoginApi.ResetEmail(values);
      setCount(5);
      setSuccessMessage(pages.login.sentOtp);
      setShowResetEmail(false);
      setShowOtp(true);
    } catch (error: any) {
      console.log({ error });
      if (error?.response?.data?.error) {
        setErrorMessage(error.response.data.error);
      } else {
        setErrorMessage(generalErrors.wentWrong);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleOtp = async (values: { otp: string }) => {
    setLoading(true);
    try {
      const user = await LoginApi.SendOTP(values);
      setShowOtp(false);
      setShowResetEmail(false);
      setOtpUser(user);
    } catch (error: any) {
      console.log({ error });
      if (error?.response?.data?.error) {
        setErrorMessage(error.response.data.error);
      } else {
        setErrorMessage(generalErrors.wentWrong);
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePassword = async (values: {
    password: string;
    confirmPassword: string;
  }) => {
    setLoading(true);
    try {
      const body = {
        password: values.password,
        confirmPassword: values.confirmPassword,
        user_id: otpUser.user_id,
      };
      await LoginApi.ChangePassword(body);
      setSuccessMessage(pages.login.passwordChanged);
      handleShowLogin();
    } catch (error: any) {
      console.log({ error });
      if (error?.response?.data?.error) {
        setErrorMessage(error.response.data.error);
      } else if (Array.isArray(error?.response?.data?.error)) {
        setErrorMessage(error.response.data.error[0].message);
      } else {
        setErrorMessage(generalErrors.wentWrong);
      }
    } finally {
      setLoading(false);
    }
  };

  const formikLogin: any = useFormik({
    initialValues: initialValuesLogin,
    validationSchema: () => login(schema),
    onSubmit: (values: any) => handleLogin(values),
  });

  const formikResetEmail: any = useFormik({
    initialValues: initialValuesResetEmail,
    validationSchema: () => resetEmail(schema),
    onSubmit: (values: any) => handleResetEmail(values),
  });

  const formikOtp: any = useFormik({
    initialValues: initialValuesOtp,
    validationSchema: () => otp(schema),
    onSubmit: (values: any) => handleOtp(values),
  });

  const formikPassword: any = useFormik({
    initialValues: initialValuesConfirmPassword,
    validationSchema: () => password(schema),
    onSubmit: (values: any) => handlePassword(values),
  });

  const handleLogout = useCallback(() => {
    // setUser(null);
    setToken(null);
    // localStorage.removeItem("user");
    localStorage.removeItem("kafd-app-token");
  }, [setToken]);

  return {
    formikLogin,
    formikResetEmail,
    formikOtp,
    formikPassword,
    loading,
    otpUser,
    handleShowLogin,
    showResetEmail,
    setShowResetEmail,
    showOtp,
    setShowOtp,
    handleLogout,
    count,
  };
};

export default useLoginContainer;